import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

class MainpageButtons extends Component {
    render() {
        return (
            <div className="row">
                <div className="hide-on-small-only">
                    <div className="col s5 center-align waves-effect waves-light lighten-1">
                        <Link to='dashboard' key='Dashboard' className='btn btn-large teal waves-effect waves-light lighten-1'><FontAwesomeIcon icon="book-open" /> Go to Dashboard</Link>
                    </div>

                    <div className="col s5 offset-m1 center-align waves-effect waves-light lighten-1">
                        <Link to='hastemplate' key='Hastemplate' className='btn btn-large teal waves-effect waves-light lighten-1'><FontAwesomeIcon icon="magic" />  Create new NDA</Link>
                    </div>
                </div>


                <div className="hide-on-med-and-up">
                    <div className="row">
                        <div className="col m8 s8 waves-effect waves-light lighten-1">
                            <Link to='dashboard' key='Dashboard' className='btn btn-large teal waves-effect waves-light lighten-1'>Dashboard</Link>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col m8 s8 waves-effect waves-light lighten-1">
                            <Link to='hastemplate' key='Hastemplate' className='btn btn-large teal waves-effect waves-light lighten-1'>New NDA</Link>
                        </div>
                    </div>
                </div>
                <div className="row">
                </div>
                <div className="row">
                </div>
                <div className="row">
                </div>
            </div>

        )
    }
}

export default MainpageButtons;